<template>
    <div class="notFound">
        <img src="@/home/assets/pc/search/notFound.svg" alt="notFound" />
        <div class="tips" v-html="tips"></div>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    @Component({})
    export default class NotFound extends Vue {
        @Prop({
            type: String,
            required: true,
        })
        keyword;
        get tips() {
            return (this.$t("tips") as string).replace("%keyword%", `<span class="bold">"${this.keyword}"</span>`);
        }
    }
</script>
<style lang="stylus" scoped>
    .notFound {
    	display: flex;
    	align-items: center;
    	justify-content: center;
    	flex-direction: column;
    	padding: 40px 10px 80px;

    	img {
    		width: 140px;
    		height: 105px;
    		margin-bottom: 8px;
    	}

    	.tips {
    		font-size: 12px;
    		line-height: 16px;
    		color: var(--fontSearchTinyColor);

    		/deep/.bold {
    			color: var(--fontSearchColor);
    		}
    	}
    }
</style>
<i18n>
{
    "zh": {
        "tips": "很抱歉，未匹配到您输入的%keyword%下面是我们为您推荐的模板，可以尝试一下~"
    },
    "en": {
        "tips": "Sorry, there is no result for %keyword%. You can try the following templates recommended for you."
    },
    "de": {
				"tips": "Leider gibt es keine Ergebnisse für %keyword%. Sie können die folgenden Vorlagen ausprobieren, die für Sie empfohlen werden."
		},
		"fr": {
				"tips": "Désolé, il n'y a aucun résultat pour %keyword%. Vous pouvez essayer les modèles suivants recommandés pour vous."
		},
		"es": {
				"tips": "Lo sentimos, no hay resultados para %keyword%. Puedes probar las siguientes plantillas recomendadas para ti."
		},
		"jp": {
				"tips": "申し訳ありませんが、%keyword%の結果はありません。お客様にお勧めの以下のテンプレートをお試しいただけます。"
		},
		"pt": {
				"tips": "Desculpe, nenhum resultado para %keyword%. Você pode experimentar os seguintes modelos recomendados para você."
		},
		"it": {
				"tips": "Nessun risultato per %keyword%. Sono disponibile i seguenti modelli consigliati per te."
		},
		"tw": {
				"tips": "抱歉，沒有%keyword%的結果。您可以嘗試下列為您建議的範本。"
		},
		"kr": {
				"tips": "죄송합니다. %keyword%에 대한 결과가 없습니다. 다음 추천 템플릿을 사용해 보세요."
		},
		"id": {
				"tips": "Sorry, there is no result for %keyword%. You can try the following templates recommended for you."
		},
		"ru": {
				"tips": "Для %keyword% результатов не найдено. Вы можете попробовать следующие рекомендуемые вам шаблоны."
		}
}
</i18n>
